// Advertisement Platform enum (matches API response)
export enum EAdvertisementPlatform {
  WEB = "WEB",
  ANDROID = "ANDROID",
  IOS = "IOS",
}

// Advertisement Status enum (matches API response)
export enum EAdvertisementStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

// Advertisement interface (matches actual API response structure)
export interface IAdvertisement extends Record<string, unknown> {
  id: string; // Changed from number to string to match API
  rank: number; // Changed from order to rank to match API
  mobileImage: string; // Added mobileImage field
  webImage: string; // Changed from image to webImage to match API
  surfaces: EAdvertisementPlatform[]; // Changed from platforms to surfaces to match API
  status: EAdvertisementStatus;
  createdAt: string;
  updatedAt: string;
}

// API Response for advertisements list (matches actual API structure)
export interface IAdvertisementsListResponse {
  status: number;
  timestamp: string;
  data: {
    promotionDtos: IAdvertisement[]; // Changed from advertisementWidgetDTOs to promotionDtos
  };
}

// API Response for single advertisement (matches actual API structure)
export interface IAdvertisementResponse {
  status: number;
  timestamp: string;
  data: IAdvertisement;
}

// Advertisement creation/update body (matches API expectations)
export interface ICreateAdvertisementBody {
  mobileImage: string;
  webImage: string;
  surfaces: EAdvertisementPlatform[];
  status: EAdvertisementStatus; // Always ACTIVE for creation
}

export interface IUpdateAdvertisementBody {
  id: string;
  mobileImage: string;
  webImage: string;
  surfaces: EAdvertisementPlatform[];
  status: EAdvertisementStatus;
}

// Advertisement API parameters
export interface IAdvertisementsParams {
  page?: number;
  size?: number;
  sort?: string;
  searchKeyWord?: string;
  status?: EAdvertisementStatus;
  platform?: EAdvertisementPlatform;
}
